const UrlBackend = 'https://backend.dbmanager.yachay.grisenergia.pt/';


export {UrlBackend};
